import { render, staticRenderFns } from "./UserHelpSearch.vue?vue&type=template&id=05dbb2f7&scoped=true&"
import script from "./UserHelpSearch.vue?vue&type=script&lang=ts&"
export * from "./UserHelpSearch.vue?vue&type=script&lang=ts&"
import style0 from "./UserHelpSearch.vue?vue&type=style&index=0&id=05dbb2f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dbb2f7",
  null
  
)

export default component.exports